import React from "react";

const PopinCta = ({ isSubscribed, isWelcomed, setIsWelcomed, props }) => {
    return (
        <React.Fragment>
            {!isSubscribed && !isWelcomed ? (
                <div className="chatbot-popin-cta" id="chatbot-popin-cta">
                    <div className="chatbot-popin-cta-content">
                        <img
                            className="chatbot-popin-cta-avatar"
                            src={props.ctaWelcomeAvatar}
                            alt=""
                        />
                        <p className="chatbot-popin-cta-message">
                            {props.ctaWelcomeMessage}
                        </p>
                    </div>
                    <span
                        className="chatbot-popin-cta-close"
                        onClick={() => {
                            setIsWelcomed(true);
                        }}
                    >
                        &times;
                    </span>
                </div>
            ) : null}
        </React.Fragment>
    );
};

export default PopinCta;
